import React from 'react';
import { Modal } from 'antd';
import illustration from '../../../assets/icons/icon-modal-non-serviceable.svg';
import Button from '../../common/Button/Button';

const NonServiceableModal = props => {
  const { visible, onChangeLocation, onCancel, launchInfo, source } = props;
  const { area, addressLine2 } = launchInfo || {};
  let content = 'Please choose your location to help you serve better!';
  let cta = 'Choose Location';
  if (!(area && addressLine2)) {
    if (source === 'location') {
      content =
        'Oh! We’re not yet active in your area. But, we are expanding quickly.\n Fresh meat will soon be available to you!';
      cta = 'Change location';
    } else if (source === 'notifyMe') {
      content =
        'Please choose your location to get notified when the product is available!';
      cta = 'Choose Location';
    }
  } else if (area || addressLine2) {
    content =
      'Oh! We’re not yet active in your area. But, we are expanding quickly.\n Fresh meat will soon be available to you!';
    cta = 'Change location';
  }
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footer={null}
      centered={true}
      wrapClassName="non-serviceable-modal"
      getContainer={false} // in desktop view, to remove "overflow: hidden" getting added to body on modal close
    >
      <div className="non-serviceable-modal--illustration">
        <img src={illustration} />
      </div>
      <div className="non-serviceable-modal--message">{content}</div>
      <div className="non-serviceable-modal--cta">
        <Button
          className="button button-primary full-width"
          onClick={onChangeLocation}
        >
          {cta}
        </Button>
      </div>
    </Modal>
  );
};

export default NonServiceableModal;
